<template>
  <main class="forgot">
    <form>
      <img class="img_glow_left" src="/static/images/home/glow.png"/>

      <slot name="main"></slot>
    </form>
  </main>
</template>

<script>
export default {
  name: 'ForgotPasswordLayout'
}
</script>



// WEBPACK FOOTER //
// src/components/visitor/forgotPassword/ForgotPasswordLayout.vue